import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=22c40872&scoped=true"
import script from "./tooltip.vue?vue&type=script&lang=js"
export * from "./tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c40872",
  null
  
)

export default component.exports